import {configSchema, configSchemaType} from "./config.schema";

export const parseConfig = (configObj: configSchemaType) => {
    const parseResult = configSchema.safeParse(configObj);
    if (!parseResult.success) throw parseResult.error;
    return parseResult.data;
}
